import { Box, Flex, Text } from "@chakra-ui/react";
import { NotificationConsentDisclosure } from "../NotificationConsentDisclosure/NotificationConsentDisclosure";

export interface TextNotificationOptInProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
}

// Single opt-in checkbox shown at first-time phone entry: does the user want
// reminders and updates by text as well as email? Unchecked by default — an
// affirmative opt-in is what makes the text consent valid. Checking it opts the
// user into text for every notification category (email stays on); they can
// fine-tune per category later in Settings → Notification. The TCPA-style
// disclosure sits directly beneath the checkbox so it's visible at opt-in time.
export const TextNotificationOptIn = ({
  checked,
  onChange,
}: TextNotificationOptInProps) => {
  return (
    <Box>
      <Flex as="label" align="flex-start" gap="0.75rem" cursor="pointer">
        <input
          type="checkbox"
          checked={checked}
          onChange={(e) => onChange(e.target.checked)}
          style={{
            flexShrink: 0,
            width: "1.125rem",
            height: "1.125rem",
            marginTop: "0.125rem",
            cursor: "pointer",
          }}
        />
        <Text textStyle="label" color="fg.default">
          Text me match notifications, event reminders and updates
        </Text>
      </Flex>
      <NotificationConsentDisclosure mt="8px" />
    </Box>
  );
};
